import React from 'react'
import { FaWhatsapp, FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import whatsapp from '../img/icon.jpg'

const Footer = () => {

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+919899450611", "_blank"); 
  };

  const handleFacebookClick = () => {
    window.open("https://www.facebook.com/people/Dr-Manish-Khattar-MCh-Urology-I-Andrology-I-Kidney-Transplant/61565204792808/?mibextid=wwXIfr&rdid=InApcTKBHWfLmDPn&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AkQtTtRoS%2F%3Fmibextid%3DwwXIfr", "_blank"); // Your Facebook profile
  };

  const handleInstagramClick = () => {
    window.open("https://www.instagram.com/urologydecoded/profilecard/?igsh=MXJyd3pzMTN4cG9q", "_blank"); // Your Instagram profile
  };

  const handleYouTubeClick = () => {
    window.open("https://www.youtube.com/yourchannel", "_blank"); // Your YouTube channel
  };
  return (
    <>
      <div className='footer'>

        <div className='foot'>
          <h1>Dr. Manish Khattar
          </h1>
          <p>Dr. Manish Khattar is an outstanding urologist with an immaculate background in medical education and clinical practice. He completed his MBBS, MS in General Surgery, and MCh in Urology from the prestigious All India Institute of Medical Sciences (AIIMS), Delhi during his stint of 13 years at the institute.</p>
        </div>

        <div className='foot'>
          <h1>OVERVIEWk</h1>
          <Link to='/'><p>Home </p></Link>
          <Link to='/'><p>Meet Our Doctor </p></Link>
          <Link to='/'><p>Reviews</p></Link>
          <Link to='/'><p>Procedures</p></Link>
        </div>

        <div className='foot'>
          <h1>SERVICES</h1>
          <Link to='/'>  <p>Endo Urology Care</p></Link>
          <Link to='/'><p>Uro Oncology Care</p></Link>
          <Link to='/'><p>Kidney Transplant</p></Link>
          <Link to='/'><p>Female Urology Care</p></Link>


        </div>

       

        <div className='foot'>
          <h1>SUPPORT</h1>
          <Link to='/'><p>Book Appointment</p></Link>
          <Link to='/'><p>Gallery</p></Link>
        </div>



      </div>

      <div className='discreption'>

        <p>@2024 Dr. Manish Khattar  Developed Designed by Creative Digital World </p>
      </div>


      <div className="social-buttons-container">
        <button className="social-button whatsapp" onClick={handleWhatsAppClick}>
          <FaWhatsapp size={20} color="white" />
        </button>
        <button className="social-button facebook" onClick={handleFacebookClick}>
          <FaFacebook size={20} color="white" />
        </button>
        <button className="social-button instagram" onClick={handleInstagramClick}>
          <FaInstagram size={20} color="white" />
        </button>
        <button className="social-button youtube" onClick={handleYouTubeClick}>
          <FaYoutube size={20} color="white" />
        </button>
      </div>



      <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
  <a href="https://wa.me/919369996314" target="_blank" rel="noopener noreferrer">
    <img 
      src={whatsapp} 
      alt="WhatsApp" 
      style={{ width: '60px', height: '60px', borderRadius: '50%' }} 
    />
  </a>
</div>



    </>
  )
}

export default Footer
